
import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { Job } from '@/models/job'
import Mixin from '@/mixins'

@Component({
  name: 'CardBlog',
})
export default class CardBlog extends mixins(Mixin) {
  @Prop({ required: false, type: Object }) readonly job: Job
}
